export default __webpack_public_path__ + "media/images/admin/users/avatar-ae7adfd358d6d23724ce5cebee7f4355.png";